import React from 'react';

/**
 * The AI Assistant's icon (owner, 2026-10-05): a speech bubble with a sparkle in
 * it and a smaller one in its open corner — "a conversation that thinks". Drawn
 * for Metanoia in lucide's grammar (24×24, 2px round strokes, currentColor) so it
 * sits beside lucide icons on the rail; lucide has no chat-with-sparkle glyph.
 * Replaced the brand orb, which belongs to Metanoia, not to one feature in it.
 */
export function AIAssistantIcon({ className = 'w-5 h-5', strokeWidth = 2, ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      data-icon="ai-assistant"
      {...rest}
    >
      {/* the bubble — its top-right corner left open for the small sparkle */}
      <path d="M14 5H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h1v3.5L10 17h9a2 2 0 0 0 2-2v-5" />
      <path d="M11 7.5c.4 2.1 1.4 3.1 3.5 3.5-2.1.4-3.1 1.4-3.5 3.5-.4-2.1-1.4-3.1-3.5-3.5 2.1-.4 3.1-1.4 3.5-3.5z" />
      <path d="M19 1.8c.25 1.25.95 1.95 2.2 2.2-1.25.25-1.95.95-2.2 2.2-.25-1.25-.95-1.95-2.2-2.2 1.25-.25 1.95-.95 2.2-2.2z" />
    </svg>
  );
}
